export { SplitPane, SplitPaneProps } from './lib/SplitPane';
